export default "__VITE_ASSET__YUsR3pQM__"